import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[space]/page.js");
